// extracted by mini-css-extract-plugin
module.exports = {"homeContent":"dp-kAVs5UeT"};